<template>
    <div class="product-buy-container">
        <img
            class="product-icon"
            :src="baseInfo.icon"
        />
        <div class="product-tip">由百度智能云云市场优选服务商提供服务</div>
        <div class="product-buy-content">
            <h1>{{ baseInfo.title }}</h1>
            <p class="des">{{ baseInfo.des }}</p>
            <div class="price-container">
                <p class="price-content">
                    <span class="label">价格：</span>
                    <span class="price">{{ baseInfo.price }}</span>
                    <span class="price-unit">{{ baseInfo.unit }}</span>
                    <img
                        class="price-icon"
                        :src="baseInfo.priceIcon"
                    />
                </p>
                <p class="price-content origin-price-content">
                    <span class="label">市场价：</span>
                    <span class="origin-price">{{ baseInfo.originPrice }}</span>
                </p>
                <div class="advantage-content">
                    <div
                        v-for="(item, index) in baseInfo.advantage"
                        :key="index"
                        class="advantage"
                    >
                        <img :src="advantageIcon[index]"/>
                        <span>{{ item }}</span>
                    </div>
                </div>
            </div>
            <!-- form-slot -->
            <slot name="form"></slot>
            <div class="form-submit-container">
                <div class="btn-content">
                    <a
                        class="purchase-btn"
                        :class="['purchase-btn', checkRule ? '' : 'disable-btn']"
                        :data-track-value="'landBuyBtn' + type"
                        :data-track-name="'落地页立即购买' + type"
                        @click="onBuy"
                    >立即购买</a>
                    <a
                        class="ask-btn"
                        :data-track-value="'landAskBtn' + type"
                        :data-track-name="'落地页立即咨询' + type"
                        @click="onAsk"
                    >
                        <img
                            class="blue-service-icon"
                            src="../assets/service.png"
                        />
                        <img
                            class="white-service-icon"
                            src="../assets/service2.png"
                        />
                        立即咨询
                    </a>
                </div>
                <div class="check-content">
                    <input
                        v-model="checkRule"
                        type="checkbox"
                        name="checkRule"
                    />
                    <span class="check-text">
                        我已阅读并同意
                        <a
                            href="https://cloud.baidu.com/doc/Market/s/ajy71lzg2"
                            target="_blank"
                        >《云市场服务协议》</a>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import fast from '../assets/fast.png';
import money from '../assets/money.png';
import yusan from '../assets/yusan.png';
export default {
    props: ['baseInfo', 'type'],
    data() {
        return {
            advantageIcon: [fast, money, yusan],
            selectDatasource: [
                {
                    text: '商标自助注册',
                    value: 'self'
                },
                {
                    text: '专家辅助注册',
                    value: 'auxiliary'
                },
                {
                    text: '商标担保注册',
                    value: 'guarantee'
                }
            ],
            selected: 'self',
            checkRule: true
        };
    },
    methods: {
        onBuy() {
            if (!this.checkRule) {
                return;
            }
            this.$emit('buy');
        },
        onAsk() {
            this.$emit('ask');
        }
    }
};
</script>

<style lang="less">
.product-buy-container {
    width: 930px;
    height: 501px;
    background: #ffffff;
    margin-bottom: 16px;
    padding: 20px 10px;
    display: flex;
    justify-content: flex-start;
    position: relative;
    .product-icon {
        width: 348px;
        height: 276px;
        margin-right: 16px;
    }
    .product-tip {
        position: absolute;
        top: 30px;
        right: 20px;
        height: 17px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 17px;
        color: #a3a3a3;
    }
    .product-buy-content {
        h1 {
            height: 33px;
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 500;
            line-height: 33px;
            color: #191c3d;
            margin: 0;
        }
        .des {
            height: 20px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 20px;
            color: #191c3d;
            opacity: 0.6;
            margin: 8px 0 16px;
        }
    }
    .price-container {
        width: 522px;
        height: 116px;
        background: url(../assets/buy_bac.png) no-repeat;
        background-size: 100% 100%;
        padding: 16px 0 0 16px;
        .price-content {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 20px;
            color: rgba(25, 28, 61, 0.35);
            display: flex;
            align-items: flex-end;
            .price {
                font-size: 22px;
                color: #ef2323;
                line-height: 28px;
            }
        }
        .price-icon {
            height: 21px;
        }
        .origin-price-content {
            margin: 3px 0 12px;
            .origin-price {
                text-decoration: line-through;
            }
        }
    }
    .advantage-content {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .advantage {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 20px;
        }
        img {
            width: 21px;
            height: 21px;
            margin-right: 4px;
        }
        span {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 21px;
            height: 21px;
            color: #2468f2;
            opacity: 0.9;
        }
    }
    .form-item {
        display: flex;
        align-items: flex-start;
        margin: 16px 0;
        .form-label {
            height: 30px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 30px;
            color: #191c3d;
            opacity: 0.7;
            margin-right: 16px;
            width: 70px;
        }
    }
    .select-item {
        height: 30px;
        background: #ffffff;
        border: 1px solid #dddddd;
        padding: 0 16px;
        line-height: 30px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #191c3d;
        opacity: 0.7;
        position: relative;
        display: inline-block;
        margin-right: 8px;
        cursor: pointer;
        .selected-img {
            position: absolute;
            top: 0;
            right: 0;
            width: 18px;
            height: 18px;
        }
    }
    .be-selected {
        border: 1px solid #2468f2;
        color: #2468f2;
        opacity: 1;
    }
    .form-list {
        padding-left: 10px;
        li {
            height: 30px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 30px;
            color: #191c3d;
            margin-bottom: 8px;
            position: relative;
        }
        li:before {
            content: '';
            width: 5px;
            height: 5px;
            background: #f03e3e;
            border-radius: 50%;
            position: absolute;
            left: -10px;
            top: 12px;
        }
    }
    .form-submit-container {
        margin-left: 86px;
        .btn-content {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
        }
        .purchase-btn {
            width: 154px;
            height: 42px;
            background: #2468f2;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            line-height: 42px;
            color: #ffffff;
            text-align: center;
            display: inline-block;
            margin-right: 20px;
            cursor: pointer;
        }
        .disable-btn {
            color: #aaa;
            background-color: #f5f5f5;
            cursor: not-allowed;
        }
        .ask-btn {
            width: 154px;
            height: 42px;
            border: 1px solid #2468f2;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            line-height: 22px;
            color: #2468f2;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            background-color: #fff;
            img {
                width: 22px;
                height: 23px;
                margin-right: 7px;
            }
            .white-service-icon {
                display: none;
            }
        }
        .ask-btn:hover {
            background-color: #2468f2;
            color: #fff;
            .white-service-icon {
                display: inline-block;
            }
            .blue-service-icon {
                display: none;
            }
        }
        .check-content {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 16px;
            input {
                margin-right: 4px;
            }
            .check-text {
                height: 20px;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 20px;
                color: #191c3d;
                opacity: 0.5;
                a {
                    text-decoration: none;
                }
            }
        }
    }
}
.form-select {
    position: relative;
    border: 1px solid #ddd;
    .input-container {
        position: relative;
        input {
            border: none;
            margin: 0;
            padding: 0 10px;
            padding-right: 20px;
            outline: none;
            height: 28px;
            line-height: 28px;
            background: none;
            font-size: 14px;
            width: 100px;
            cursor: pointer;
            color: #191c3d;
        }
        .input-suffix {
            position: absolute;
            width: 11px;
            height: 7px;
            top: 11px;
            right: 4px;
        }
    }
    .select-container {
        position: absolute;
        top: 32px;
        left: 0;
        height: auto;
        max-height: 200px;
        border: 1px solid #ddd;
        overflow-y: auto;
        padding: 0;
        z-index: 100;
        background-color: #fff;
        width: 100px;
        li {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            height: 30px;
            line-height: 30px;
            cursor: pointer;
            color: #191c3d;
            padding: 0 10px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #191c3d;
        }
        li:hover {
            background: #eaf6fe;
            color: #108cee;
        }
        .li-selected {
            background: #eaf6fe;
            color: #108cee;
        }
    }
}
</style>
